<template>
  <div class="content-card">
    <div
      class="row mt-5 justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
    >
      <div class="mb-3 col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
        <h1 class="subtitle-card">CARRITO DE COMPRAS</h1>
      </div>
      <div class="col-12 col-md-12 col-lg-11 col-xl-11 col-sm-12">
        <template v-if="itemsCards.length == 0">
          <div class="alert alert-primary " role="alert">
            No se encontraron productos en el carrito de compras
          </div>
          <router-link class="btn btn-danger" to="catalogo">Catálogo</router-link>
        </template>
        <template v-else>
          <div class="table-responsive">
            <table class="table table-light table-h">
              <thead>
                <tr class="tr-table-h">
                  <th class="th-title" scope="col">Producto</th>
                  <th class="th-title" scope="col">Precio</th>
                  <th class="th-title" scope="col">Cantidad</th>
                  <!-- <th class="th-title" scope="col">Número</th> -->
                  <th class="th-title" scope="col"></th>
                  <th class="th-title" scope="col">Total</th>
                  <th class="th-title" scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="tr-table-h" v-for="(item, i) in itemsCards" :key="item.id">
                  <td class="td-card">
                    <img alt="Productos..." class="prod-card" :src="item.products.img" />
                    <small>{{ item.products.name }}</small>
                  </td>
                  <td>
                    <h5>
                      <span v-if="item.products.type_catalogue == 1 || item.products.type_catalogue == null" class="mt-2 badge badge-pill badge-info">
                        Puntos: {{ item.products.discount != null ? item.products.points_discount : item.products.points }}
                      </span>
                      <span v-if="item.products.type_catalogue == 2" class="mt-2 badge badge-pill badge-info">
                        Puntos: {{ item.products.discount_lub != null ? item.products.points_discount_lub : item.products.points_lub }}
                      </span>
                      <span v-if="item.products.type_catalogue == 3 && item.products.points > 0 && rol == 5" class="mt-2 badge badge-pill badge-info">
                        Puntos: {{ item.products.discount != null ? item.products.points_discount : item.products.points }}
                      </span>
                      <span v-if="item.products.type_catalogue == 3 && item.products.points_lub > 0 && rol == 4" class="mt-2 badge badge-pill badge-info">
                        Puntos: {{ item.products.discount_lub != null ? item.products.points_discount_lub : item.products.points_lub }}
                      </span>
                    </h5>
                  </td>
                  <td>
<!--                    <h5 v-if="item.products.stock == 0">-->
<!--                      <span class="badge bg-light text-dark"-->
<!--                        >No disponible</span-->
<!--                      >-->
<!--                    </h5>-->
                    <div class="form-group">
                      <div class="input-group mt-3 ">
                        <input
                          size="1"
                          v-model="item.quantity"
                          class="form-control"
                          type="text"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  <!-- <td>
                    <input
                      v-model="item.numberPhone"
                      type="text"
                      :placeholder="item.placeholder"
                      :disabled="item.disabled"
                      class="form-control"
                    />
                  </td> -->
                  <td>
                    <i
                      id="info-icon"
                      style="cursor: pointer;"
                      class="fa fa-question-circle fa-lg text-info pt-3"
                      :class="'infoIcon' + i"
                      @click="showInfo(i)"
                      :title="item.info"
                    ></i>
                  </td>
                  <td>
                    <h5>
                      <span v-if="item.products.type_catalogue == 1 || item.products.type_catalogue == null" class="mt-2 badge badge-pill badge-danger">
                        Puntos: {{ item.products.discount != null ? item.products.points_discount : item.products.points }}
                      </span>
                      <span v-if="item.products.type_catalogue == 2" class="mt-2 badge badge-pill badge-danger">
                        Puntos: {{ item.products.discount_lub != null ? item.products.points_discount_lub : item.products.points_lub }}
                      </span>
                      <span v-if="item.products.type_catalogue == 3 && item.products.points > 0 && rol == 5" class="mt-2 badge badge-pill badge-danger">
                        Puntos: {{ item.products.discount != null ? item.products.points_discount : item.products.points }}
                      </span>
                      <span v-if="item.products.type_catalogue == 3 && item.products.points_lub > 0 && rol == 4" class="mt-2 badge badge-pill badge-danger">
                        Puntos: {{ item.products.discount_lub != null ? item.products.points_discount_lub : item.products.points_lub }}
                      </span>
                    </h5>
                  </td>
                  <td>
                    <i
                      data-toggle="tooltip"
                      data-placement="left"
                      title="Eliminar producto del carrito de compras"
                      class="mt-3 icon-close-card fa fa-times-circle-o text-danger fa-lg infoClose"
                      style="cursor: pointer;"
                      aria-hidden="true"
                      @click="remocerCard(i, item)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <div class="col-12  col-total">
          <div
            class="card  card-total"
            style="max-width: 18rem;  background-color: #1da5df"
          >
            <div class="card-body" style="color: #fff">
              <label class=" mt-3" style="float: left; font-size: 18px;"
                ><b>TOTAL</b></label
              ><label class="mt-3" style="float: right; font-size: 18px;"
                ><b>{{ total }} puntos</b></label
              >
            </div>

            <button
              type="button"
              @click="buy()"
              class="btn btn-danger btn-block btn-shop"
            >
              <span
                v-if="loading.btn"
                class="spinner-border spinner-border-md"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Comprar</template>
            </button>
          </div>
        </div>
<!--        <div class="col-12  col-total">-->
<!--           <small v-if="disabled.btn" style="color: red">Elimine los productos que no están disponibles para continuar</small>-->
<!--        </div>-->
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <p class="subtitle-card text-center" style="margin: 0px;">
              DETALLES DEL DESTINATARIO.
            </p>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <formAddress
              :flagSoat="flagSoat"
              @cancel="cancelar($event)"
              @buy="confirmation($event)"
            ></formAddress>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal 2 -->
    <div
      class="modal fade"
      id="modalMessage"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="modalMessageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content" style="border-radius: 40px;">
          <div class="modal-body">
            <img alt="Bien" width="100" src="../../../assets/icon/bien.png" class="mb-3" />
            <p class="text-danger p-me pb-0 mb-0">¡FELICITACIONES!</p>
            <p class="text-danger p-me mb-0">HAS REDIMIDO ESTE PRODUCTO</p>
            <p class="text-danger p-me mb-0">DE MANERA EXITOSA.</p>
            <p class="text-center" style="color: gray">
              <i>{{ message }}</i>
            </p>
            <p class="text-center" style="color: gray">
              <i>
                Para un mayor detalle de tu compra dirígete al historial de
                compras en tu perfil.
              </i>
            </p>
            <button class="btn btn-danger" @click="irPro()">ACEPTAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from "@/config/auth";
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import formAddress from "./formAddress";
import axios from 'axios';

export default {
  name: "navbar",
  components: {
    formAddress: formAddress
  },
  computed: {
    ...mapState(["productCard", "itemsCards"])
  },
  data() {
    return {
      flagSoat: false,
      contND: 0,
      message: "Tu producto llegará a la dirección suministrada en un periodo máximo de 30 días hábiles.",
      openModal: false,
      tooltip: {
        info: true,
        close: false
      },
      total: 0,
      items: [],
      errors: {
        quantity: false
      },
      quantity: 1,
      cont: 1,
      disabled: {
        btn: false
      },
      loading: {
        btn: false
      },
      itemsCards: [],
      rol: null,
    };
  },
  methods: {
    irPro() {
      var rol = sessionStorage.getItem("dXNlclJvbGU=");
      var rolde = atob(rol);
      if (parseInt(rolde) == 4) {
        this.$router.push({ name: "lubricatorProfile" });
      } else {
        this.$router.push({ name: "profileUser" });
      }
      $("#modalMessage").modal("hide");
    },
    showModal(data) {
      var numTypeTexaco = false;
      var numTypeMoto = false;
      var numTypeWon = false;

      for (let i = 0; i < data.length; i++) {
        if (data[i].productType == 5) {
          numTypeTexaco = true;
        }
        if (data[i].productType == 3) {
          numTypeMoto = true;
        }
        if (
          data[i].productType == 1 ||
          data[i].productType == 2 ||
          data[i].productType == 4
        ) {
          numTypeWon = true;
        }
      }
      // if de verificación de modal a mostrar
      if (numTypeWon) {
        // console.log("Modal de won");
        var html = "Felicidades, se ha hecho la compra correctamente <br><br> Productos comprados: <br>";
        for (let i = 0; i < data.length; i++) {
          if (data[i].status.status_id == 4) {
            html +=
              "<b>" +
              data[i].productName +
              "</b> puntos: " +
              data[i].productPoints +
              " <br> Para un mayor detalle de tu compra dirígete al historial de compras en tu perfil. <br>";
          }
        }
        html += "<br> Productos que fueron rechazados: <br> ";
        for (let i = 0; i < data.length; i++) {
          if (data[i].status.status_id == 7) {
            html += "<b>" + data[i].productName + "</b> rechazado por el operador <br>";
          }
        }
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "success",
          title: "Muy bien",
          text: "",
          html: html
        });
        return false;
      } else if (numTypeMoto) {
        // console.log("Modal de motoss");
        this.message =
          "Tu producto llegará a la dirección suministrada en un periodo máximo de 30 días hábiles.";
        $("#modalMessage").modal("show");
        setTimeout(() => {
          $("#modalMessage").modal("hide");
        }, 7000);
        return false;
      } else {
        this.message = "";
        $("#modalMessage").modal("show");
        setTimeout(() => {
          $("#modalMessage").modal("hide");
        }, 7000);
        return false;
      }
    },
    confirmation(e) {
      $("#staticBackdrop").modal("hide");
      var app = this;
      var products = [];
      this.itemsCards.forEach(element => {
        products.push({
          sizeId: element.size_id,
          id: element.products.id,
          quantity: element.quantity,
          mobile: element.numberPhone,
          wonCategory: element.products.product_type_id,
          won: true,
          id_won: element.products.id_won,
          type_catalogue: element.products.type_catalogue
        });
      });

      var data = {
        userData: e,
        products: products,
        totalPoints: app.total
      };
      // console.log("data: ", JSON.stringify(data));
      this.loading.btn = true;

      setTimeout(function() {
        axios
          .post("superAdmin/commerce/couponPay", data)
          .then(async(res) => {
            app.loading.btn = false;
            if (res.data.cod == 0) {
              // console.log("res.data: ", JSON.stringify(res.data));
              if(app.flagSoat){
                let requestId = "";
                for(var j = 0; j < res.data.data.length; j++){
                  if(res.data.data[j].productType == 7){
                    requestId = res.data.data[j].requestId;
                  }
                }
                const formData = new FormData();
                formData.append("img", e.imgs[0].file);
                // formData.append("imgCard", e.imgs[1].file);
                formData.append("requestId", requestId);
                app.saveSoatImgs(formData, e.imgs[1].file, requestId);
              }else{
                app.showModal(res.data.data);
                app.getListCard();
                app.$store.commit("totalPoints", 0);
              }
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message
              });
            }
          })
          .catch(error => {
            console.log("error: ", error);
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Accion no disponible en este momento..."
            });
            app.loading.btn = false;
          });
      }, 500);
    },
    saveSoatImgs(formData, tarjeta, requestId){
      var app = this;
      app.loading.btn = true;
      setTimeout(function() {
        axios
          .post("superAdmin/commerce/loadImgSoatRequest", formData)
          .then(res => {
            app.loading.btn = false;
            if (res.data.cod == 0) {
              const formData2 = new FormData();
              formData2.append("img", tarjeta);
              formData2.append("requestId", requestId);
              app.saveTarjetImgs(formData2);
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message
              });
            }
          })
          .catch(error => {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
            app.loading.btn = false;
          });
      }, 500);
    },
    saveTarjetImgs(formData2){
      var app = this;
      app.loading.btn = true;
      setTimeout(function() {
        axios
          .post("superAdmin/commerce/loadImgSoatCardRequest", formData2)
          .then(res => {
            app.loading.btn = false;
            if (res.data.cod == 0) {
              // console.log("res.data formData: ", JSON.stringify(res.data));
              app.showModal(res.data.data);
              app.getListCard();
              app.$store.commit("totalPoints", 0);
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message
              });
            }
          })
          .catch(error => {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
            app.loading.btn = false;
          });
      }, 500);
    },
    showInfo(i) {
      if (this.tooltip.info) {
        $(".infoIcon" + i).tooltip("show");
        this.tooltip.info = false;
      } else {
        $(".infoIcon" + i).tooltip("hide");
        this.tooltip.info = true;
      }
    },
    cancelar(e) {
      if (e) {
        $("#staticBackdrop").modal("hide");
      }
    },
    async getListCard() {
      let app = this;
      await axios
        .get("superAdmin/commerce/getShoppingCart")
        .then(res => {
          if (res.data.cod == 0) {
            app.itemsCards = res.data.data;
            app.$store.commit("totalPoints", app.itemsCards.length);
            app.itemsCards.forEach(elem => {
              if (elem.products.seller_id == 4) {
                elem.placeholder = "Número de la tarjeta";
                elem.disabled = false;
              } else if (elem.products.seller_id == 12) {
                elem.disabled = true;
              } else if (elem.products.seller_id == null) {
                elem.disabled = true;
                elem.placeholder = "";
              } else {
                elem.disabled = false;
                elem.placeholder = "Número de celular";
                elem.info = "Indique en la caja de texto el número de celular que recibirá la recarga.";
              }
              if(!app.flagSoat){
                app.flagSoat = elem.products.product_type_id == 7 ? true : false;
              }
              elem.infoBool = true;
              if (elem.products.stock == 0) {
                this.contND++;
              }
            });
          }
          if (this.contND > 0) {
            this.disabled.btn = true;
          } else {
            this.disabled.btn = false;
          }
        })
        .catch(error => {});
    },
    remocerCard(i, item) {
      this.flagSoat = item.products.product_type_id == 7 ? false : this.flagSoat
      this.itemsCards.splice(i, 1);
      var data = {
        quantity: item.quantity,
        item: i
      };
      this.getUserSesion();
      this.contND--;
      if (this.contND > 0) {
        this.disabled.btn = true;
      } else {
        this.disabled.btn = false;
      }
      axios
        .delete("superAdmin/commerce/cart/" + item.products.id)
        .then(res => {
          this.$store.commit("removeCard", 1);
        })
        .catch(error => {});
    },
    irCatalogo() {
      this.$router.push({ name: "catalogueEcommerce" });
    },
    validateNumber() {
      this.itemsCards.forEach(elem => {
        if (elem.numberPhone == null) {
          this.$swal("Ingrese el número de celular", "error");
          return false;
        }
      });
    },
    validateOpenModal() {},
    buy() {
      var contCategory = 0;
      var check = false;
      this.itemsCards.forEach(element => {
        if (
          element.products.product_type_id == 1 ||
          element.products.product_type_id == 2
        ) {
          if (element.numberPhone == null) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Todos los campos son obligatorios."
            });
            check = true;
            return false;
          }
        }
        if (element.category_id == 0 || element.category_id == 1) {
          contCategory++;
        }
      });
      if (check) {
        return false;
      }
      if (contCategory > 0) {
        $("#staticBackdrop").modal("show");
      } else {
        this.confirmation(null);
      }
    },
    getUserSesion(){
      var app = this;
      app.flagUser = localStorage.getItem('flagUser');
      axios.get("api/showUser").then(function(res) {
        if(res.data.ResponseCode == 0){
          app.user = res.data.User;
          app.rol = app.user.role_id;
          app.total = 0;
          app.itemsCards.forEach(element => {
            element.numberPhone = null;
            if(app.rol == 5){
              if(element.products.discount != null){
                app.total += parseInt(element.products.points_discount);
              } else {
                app.total += parseInt(element.products.points);
              }
            }
            if(app.rol == 4){
              if(element.products.type_catalogue == 2){
                if(element.products.discount_lub != null){
                  app.total += parseInt(element.products.points) + parseInt(element.products.points_discount_lub);
                } else {
                  app.total += parseInt(element.products.points) + parseInt(element.products.points_lub);
                }
              }
              else if(element.products.type_catalogue == 3){
                if(element.products.discount_lub != null){
                  app.total += parseInt(element.products.points_discount_lub);
                } else {
                  app.total += parseInt(element.products.points_lub);
                }
              }
            }
          });
        }
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
    },
    // countPoint() {
    //   this.total = 0;
    //   this.itemsCards.forEach(element => {
    //     element.numberPhone = null;
    //     if(this.rol == 5){
    //       this.total += parseInt(element.products.points);
    //     }
    //     if(this.rol == 4){
    //       this.total += parseInt(element.products.points) + parseInt(element.products.points_lub);
    //     }
    //   });
    // },
  },
  async mounted() {
    await this.getListCard();
    this.getUserSesion();
    // this.countPoint();
  }
};
</script>

<style>
.btn-shop {
  border-radius: 0px 0px 25px 25px;
}
.p-me {
  font-family: "Gotham-UltraItalic";
  font-size: 24px;
}
.col-total {
  padding: 10px;
  display: flex;
  justify-content: flex-end;
}
.card-total {
  width: 80%;
  border-radius: 25px;
}
.icon-close-card:hover {
  color: black !important;
}
.td-card {
  padding: 0px !important;
}
.table-h {
  border-radius: 25px;
}
.table-light tbody + tbody,
.table-light td,
.table-light th,
.table-light thead th {
  border-color: #d8d8dc;
}
.prod-card {
  width: 100px;
}
.content-card {
  padding-top: 3%;
  padding-bottom: 3%;
  background-color: #eaeaea;
  background-size: cover;
  background-image: url("../../../assets/shop.png");
  background-position: center center;
  background-attachment: fixed;
}
.subtitle-card {
  color: #dc3545;
  font-size: 28px;
  font-family: "GothamBoldItalic";
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

/* TABLET */
@media (max-width: 1023px) {
  .card-total {
    width: 80%;
  }
  .col-total {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .card-total {
    width: 80%;
  }
  .col-total {
    padding: 10px;
    display: flex;
    justify-content: center;
  }
}
</style>